import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { ServiceTypLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MultiSelect } from '../Select/MultiSelect';

interface ServiceTypProps {
    disabled?: boolean;
    value: string[];
    renderLabel?: 'label' | 'placeholder';
    onChange: (newValue: string[]) => void;
}

export const ServiceTypMulti: React.FC<ServiceTypProps> = ({
    value,
    disabled = false,
    renderLabel = 'label',
    onChange,
}) => {
    const options = React.useMemo(() => {
        const list: SelectOption[] = [];

        Object.keys(ServiceTypLabel).forEach((key) => {
            list.push({
                value: key,
                label: ServiceTypLabel[key],
            });
        });

        return list;
    }, []);

    const selectedOptions = React.useMemo(() => {
        return value.map((v) => ({
            value: v,
            label: ServiceTypLabel[v] || v,
        }));
    }, [value]);

    return (
        <>
            {renderLabel === 'label' && <Label>Art</Label>}
            <MultiSelect
                name="typ"
                isDisabled={disabled}
                value={selectedOptions}
                options={options}
                onChange={(newOptions: ValueType<SelectOption, true>): void => {
                    onChange(((newOptions || []) as SelectOption[]).map((option) => option.value));
                }}
                placeholder={renderLabel === 'placeholder' ? 'Art' : ''}
            />
        </>
    );
};
